export default {"src":"/_next/static/media/subscribe_pink_169x45.dbd7c4c8.svg","height":45,"width":170,"blurWidth":0,"blurHeight":0};